const form = {
  formId: "oil-gas-06",
  formField: {
    checkbox1: {
      name: "checkbox1",
      label: "[01] Dầu thô",
      type: "text",
    },
    checkbox2: {
      name: "checkbox2",
      label: "[02] Condensate",
      type: "text",
    },
    checkbox3: {
      name: "checkbox3",
      label: "[03] Khí thiên nhiên",
      type: "text",
    },
    checkbox4: {
      name: "checkbox4",
      label: "[04] Kết dư dầu",
      type: "text",
    },
    checkbox5: {
      name: "checkbox5",
      label: "[05] Kết dư condensate",
      type: "text",
    },
    checkbox6: {
      name: "checkbox6",
      label: "[06] Kết dư khí",
      type: "text",
    },
    checkbox7: {
      name: "checkbox1",
      label: "[20] Tên đơn vị được ủy quyền",
      type: "text",
    },
    checkbox8: {
      name: "checkbox2",
      label: "Hoặc đại lý thuế",
      type: "text",
    },
    taxCalculationPeriod: {
      name: "taxCalculationPeriod",
      label: "[07] Kỳ tính thuế:",
      type: "number",
      placeholder: "01/2023",
      errorMsg: "Vui lòng chọn kỳ tính thuế",
    },
    firstTime: {
      name: "firstTime",
      label: "[08] Lần đầu:",
      type: "text",
    },
    supplementaryForThe: {
      name: "supplementaryForThe",
      label: "[09] Bổ sung lần thứ:",
      type: "number",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập bổ sung lần thứ",
      invalidMsg: "Số không hợp lệ",
    },
    taxpayerName: {
      name: "taxpayerName",
      label: "[10] Tên người nộp thuế",
      type: "text",
      errorMsg: "Vui lòng nhập tên người nộp thuế",
    },
    taxId: {
      name: "taxId",
      label: "[11] Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    contract: {
      name: "contract",
      label: "[12] Hợp đồng dầu khí (PSC) lô",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập mã hợp đồng",
    },
    taxId2: {
      name: "taxId2",
      label: "[13] Mã số thuế hợp đồng dầu khí",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    address: {
      name: "address",
      label: "[14] Địa chỉ nhà điều hành PSC",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập địa chỉ",
    },
    province: {
      name: "province",
      label: "[16] Tỉnh / thành phố",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn tỉnh / thành phố",
    },
    district: {
      name: "district",
      label: "[15] Quận / huyện",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn quận / huyện",
    },
    phone: {
      name: "phone",
      label: "[17] Điện thoại:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập số điện thoại",
      invalidMsg: "Số điện thoại không hợp lệ",
    },
    fax: {
      name: "fax",
      label: "[18] Fax:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập fax",
    },
    email: {
      name: "email",
      label: "[19] Email:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập email",
      invalidMsg: "Email không hợp lệ",
    },
    taxId3: {
      name: "taxId3",
      label: "[18] Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    unitType: {
      name: "unitType",
      label: "Loại đơn vị tiền",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn đơn vị tiền",
    },

    fullName: {
      name: "fullName",
      label: "Họ và tên",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng họ và tên",
    },
    certificate: {
      name: "certificate",
      label: "Chứng chỉ hành nghề số:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập chứng chỉ hành nghề số",
    },
    signer: {
      name: "signer",
      label: "Người ký",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập người ký",
    },
    timeSign: {
      name: "timeSign",
      label: "Ngày ký",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng chọn ngày ký",
    },
  },
};

export default form;
